import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const SectionLoader = ({ size = 24 }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" padding={1}>
      <CircularProgress size={size} />
    </Box>
  );
};

export default SectionLoader;
